<template>
  <v-container>
    <v-row>
      <v-col cols="12">

        <v-card width="100%" height="100%">
          
          <v-card-title primary-title>
            Catálogo de Plantas

            <v-spacer></v-spacer>

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar Plantas"
              single-line
              hide-details
            ></v-text-field>


            <v-spacer></v-spacer>

            <!-- EXCEL -->
            <v-btn align="right" class="ma-2" small color="green" dark >
              <download-excel
                class="btn btn-default"
                :data="json_data"
                :fields="json_fields"
                worksheet="My Worksheet"
                name="Plantas.xls"
              >
                Excel
                <v-icon class="ma-1">mdi-download</v-icon>
              </download-excel>
            </v-btn>
            
            <!-- NUEVO -->
            <v-btn align="right"
              color="orange" dark small
              class="ma-2"
              :to="{ name: 'newplanta' }" >Nuevo
            </v-btn>

          </v-card-title>

            <v-card-text>

              <v-data-table
                :loading="loading"
                :headers="headers"
                :items="plantas"
                class="elevation-1"
                fixed-header
                height="450"
                hide-default-footer
                loading-text="Cargando..."
                dense
                :search="search"
                :items-per-page=200
                calculate-widths
                >

              <template v-slot:item="{ item }" >
               <tr v-on:dblclick.prevent.stop="edit(item)">
                  <td>{{ item.idplanta }}</td>
                  <td>{{ item.nomplanta }}</td>
                  <td>{{ item.codplanta }}</td>

                   <!-- <v-chip small
                    :color="getColor(item.estatus)"
                    dark class="align-end"
                    >
                    {{ item.estatus }}
                  </v-chip> -->
               </tr>
             </template>
             

            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {

  data: () => ({
    dialog: false,
    headers: [
      { text: 'ID', align: 'left',sortable: false, value: 'idplanta' },
      { text: 'Nombre de la planta'   , value: 'nomplanta' },
      { text: 'Codigo de la planta'     , value: 'codplanta' },
      // { text: 'Estatus'     , value: 'estatus', align:'start'},
    ],
    plantas: [],
    search: '',
    loading: false,

    json_fields: {
      Id: "idplanta",
      Planta: "nomplanta",
      Tipo: "codplanta"

    },
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    json_data: [],
            
  }),

    
  created () {
    this.init()
  },

  methods: {

    getColor (estatus) {
      if (estatus > 1) return 'green'
      else if (estatus > 2) return 'orange'
      else return 'red'
    },

    edit(planta){
      this.$router.push({name:'newplanta',
        params: planta
      })
    },

    init () {
      //Consultar Usuarios
      this.loading = true

      this.$http.get('v2/plantas.list').then( response => {
        if (response.data.result != null){
          this.plantas = response.data.result
          this.json_data = response.data.result
        }
        console.log(response)

      }).catch(error => {
        console.log(error)
      }).finally(()  => this.loading = false)
  
    }

  }
}
</script>